export const howItWorks = {
  hero: {
    badge: "Complete gids",
    title: "Hoe werkt DONKEY TRAVEL?",
    subtitle:
      "Ontdek stap voor stap hoe u uw Airbnb-woning kunt ruilen met andere eigenaren en gratis door heel Europa kunt reizen.",
    cta: "Nu beginnen",
    learnMore: "Bekijk de stappen",
  },
  stats: {
    properties: "Beschikbare woningen",
    exchanges: "Gerealiseerde ruilen",
    countries: "Gedekte landen",
    satisfaction: "Tevredenheid",
  },
  steps: {
    badge: "Het proces",
    title: "Uw ruil in 7 stappen",
    subtitle:
      "Een eenvoudig en veilig traject, van inschrijving tot uw eerste gratis reis",
    step1: {
      title: "Maak uw profiel aan (15 min)",
      description:
        'Dit is de "langste" stap: 15 minuten om uw profiel aan te maken. Een kleine moeite voor jarenlang gratis vakantie en geluk!',
      highlight1: "Abonnement vereist",
      highlight2: "Volledige advertentie met foto's",
      highlight3: "Identiteitsverificatie",
      badge: "Snelle inschrijving",
    },
    step2: {
      title: "Verken en vind uw ideale bestemming",
      description:
        "Blader door onze interactieve kaart van Europa en vind geverifieerde leden van de club. Filter op bestemming, data, type woning en voorzieningen om uw ruil te organiseren.",
      highlight1: "Interactieve kaart van Europa met geavanceerde filters",
      highlight2: "Zoeken op bestemming, data en voorzieningen",
      highlight3: "Geverifieerde host-leden in de beschikbare Europese landen",
      badge: "Slim zoeken",
    },
    step3: {
      title: "Doe een ruilvoorstel en onderhandel",
      description:
        "Neem contact op met de eigenaar die u interesseert en stel een ruil voor. Onderhandel over de data en de duur in een vriendelijke sfeer. 10 nachten tegen 5? Alles is mogelijk!",
      highlight1: "Geïntegreerde en beveiligde berichten",
      highlight2: "Flexibele onderhandeling over de duur",
      highlight3: "Geverifieerde profielen en raadpleegbare beoordelingen",
      badge: "Eenvoudig onderhandelen",
    },
    step4: {
      title: "Bevestig de data en synchroniseer uw kalenders",
      description:
        "Zodra er een akkoord is, bevestigt u de ruildata. Uw Airbnb- en TRAVELTROK-kalenders worden automatisch gesynchroniseerd om boekingsconflicten te voorkomen.",
      highlight1: "Automatische synchronisatie met Airbnb",
      highlight2: "Herinneringen en meldingen voor het verblijf",
      highlight3: "Flexibele wijziging tot 48 uur van tevoren",
      badge: "Gesynchroniseerde kalender",
    },
    step5: {
      title: "Vriendschappelijk contract in PDF verzonden naar beide hosts",
      description:
        "DONKEY TRAVEL maakt een vriendschappelijk contract in PDF en stuurt dit naar beide hosts. Zodra de eerste ruil is voltooid, heeft u 24 maanden om de wederkerige ruil uit te voeren.",
      highlight1:
        "Vriendschappelijk PDF-contract automatisch verzonden naar 2 hosts",
      highlight2: "Samenvattend document van gevalideerde data en voorwaarden",
      highlight3:
        "24 maanden om de wederkerige ruil uit te voeren na het eerste verblijf",
      badge: "PDF-contract",
    },
    step6: {
      title: "Reis en geniet van uw gratis verblijf!",
      description:
        "Het is de grote dag! Installeer u in uw ruilwoning en geniet van een authentieke vakantie. Laat na uw verblijf een beoordeling achter om de gemeenschap te helpen.",
      highlight1: "Persoonlijk welkom door de eigenaar",
      highlight2: "Lokale gids met aanbevelingen",
      highlight3: "Beoordelingssysteem na elke ruil",
      badge: "Goede reis!",
    },
  },
  advantages: {
    badge: "Onze voordelen",
    title: "Waarom kiezen voor DONKEY TRAVEL?",
    subtitle:
      "Een platform bedacht voor Airbnb-eigenaren die anders willen reizen",
    items: {
      security: {
        title: "Maximale veiligheid",
        description:
          "Alle leden zijn geverifieerde Airbnb-eigenaren. Identiteit gecontroleerd, beoordelingen beschikbaar en verzekering inbegrepen voor elke ruil.",
      },
      savings: {
        title: "Aanzienlijke besparingen",
        description:
          "Reis gratis door uw nachten te ruilen. Bespaar gemiddeld € 2.500 per jaar op uw verblijfskosten.",
      },
      community: {
        title: "Vertrouwde gemeenschap",
        description:
          "Word lid van onze reizigersgemeenschap. Deel uw ervaringen, wissel tips uit en smeed duurzame banden.",
      },
      support: {
        title: "Ondersteuning 7/7",
        description:
          "Ons team staat altijd voor u klaar. Live chat, e-mail en telefoon voor volledige ondersteuning.",
      },
      quality: {
        title: "Kwaliteitswoningen",
        description:
          "Elke woning wordt geverifieerd en beoordeeld door de gemeenschap. Hoge standaarden om uitzonderlijke verblijven te garanderen.",
      },
      global: {
        title: "Europees netwerk",
        description:
          "Toegang tot geverifieerde hosts in de beschikbare Europese landen van de club en organiseer uw ruilen in vertrouwen.",
      },
    },
  },
  testimonials: {
    badge: "Getuigenissen",
    title: "Ze hebben het getest en goedgekeurd",
    subtitle: "Ontdek de ervaringen van onze leden over de hele wereld",
    banner: {
      title: "Ook jij kunt vaker reizen!",
      subtitle: "Sluit je aan bij de community van hosts die anders reizen.",
    },
    items: {
      sophie: {
        name: "Sophie",
        location: "Parijs, Frankrijk",
        badge: "2 ruilen",
        text: "Dankzij DONKEY TRAVEL heb ik Barcelona, Rome en Amsterdam bezocht zonder accommodatie te betalen. De community reageert snel en ruilgesprekken verlopen soepel.",
      },
      marc: {
        name: "Marc",
        location: "Marseille, Frankrijk",
        badge: "1 ruil",
        text: "Het proces is ongelooflijk eenvoudig. In 3 dagen vond ik de perfecte ruil voor mijn zomervakantie. De synchronisatie met Airbnb is een enorm pluspunt.",
      },
      leaTom: {
        name: "Léa & Tom",
        location: "Lyon, Frankrijk",
        badge: "Nieuwe leden",
        text: "Wat ons het meest opviel, is de community. Eigenaren zijn attent, en de uitwisselingen vinden plaats in een sfeer van volledig vertrouwen.",
      },
      dupont: {
        name: "Familie Dupont",
        location: "Bordeaux, Frankrijk",
        badge: "3 ruilen",
        text: "Ideaal voor familiereizen tijdens de schoolvakanties!",
      },
      alex: {
        name: "Alex",
        location: "Berlijn, Duitsland",
        badge: "5 ruilen",
        text: "Een ongelooflijk netwerk voor telewerken. Ik ruil mijn loft in Berlijn voor zonnige appartementen.",
      },
      marie: {
        name: "Marie",
        location: "Toulouse, Frankrijk",
        badge: "4 ruilen",
        text: "Geen financiële beperkingen meer! Ik ga elke maand een weekendje weg.",
      },
      testimonial2: {
        text: "Het proces is zo eenvoudig. In 3 dagen had ik een perfecte ruil gevonden voor mijn zomervakantie. De synchronisatie met Airbnb is een echt pluspunt.",
      },
      testimonial3: {
        text: "Wat me het meest aansprak, is de gemeenschap. De eigenaren zijn welwillend en de uitwisselingen vinden plaats in een sfeer van totaal vertrouwen.",
      },
    },
  },
  faq: {
    title: "Veelgestelde vragen",
    subtitle: "Alles wat u moet weten voordat u begint",
    items: {
      q1: {
        question: "Is inschrijving betaald?",
        answer:
          "Ja. Toegang tot DONKEY TRAVEL gaat via een jaarabonnement. Lanceeraanbieding 2026: 25EUR/jaar in plaats van 50EUR/jaar.",
      },
      q2: {
        question: "Moet ik Airbnb-eigenaar zijn om me in te schrijven?",
        answer:
          "Ja, DONKEY TRAVEL is gereserveerd voor eigenaren met een woning op Airbnb. Dit garandeert de kwaliteit en betrouwbaarheid van elk lid van de gemeenschap.",
      },
      q3: {
        question: "Hoe worden de ruilen beschermd?",
        answer:
          "Elke ruil wordt gedekt door onze partnerverzekering. Bovendien zijn alle leden geverifieerd (identiteit, woning, Airbnb-beoordelingen) en is ons supportteam 7/7 beschikbaar.",
      },
      q4: {
        question: "Kan ik ruilen met iemand in een ander land?",
        answer:
          "Ja. U kunt ruilen met andere geverifieerde hosts in de beschikbare Europese landen, afhankelijk van uw abonnement.",
      },
      q5: {
        question: "Wat gebeurt er als de ruil wordt geannuleerd?",
        answer:
          "Ons annuleringsbeleid beschermt beide partijen. In geval van annulering helpen we u een alternatief te vinden.",
      },
      q6: {
        question: "Hoe lang duurt een ruil gemiddeld?",
        answer:
          "De duur is volledig flexibel en wordt onderhandeld tussen de twee eigenaren. Gemiddeld duren ruilen tussen 5 en 14 nachten, maar sommigen ruilen een weekend of een hele maand.",
      },
    },
  },
  cta: {
    title: "Klaar om gratis te reizen?",
    subtitle: "Word lid van onze reizigersgemeenschap.",
    explore: "Bestemmingen verkennen",
    members: "Actieve leden",
    countries: "Beschikbare landen",
    satisfaction: "Tevredenheid",
  },
};
